module.exports = __webpack_public_path__ + "img/icon_map_36_on_001.d8c36ebf.png";